import {
	ADD_PROJECT_SUCCESS,
	ADD_PROJECT_FAIL,
	GET_PROJECT_SUCCESS,
	GET_PROJECT_FAIL,
	GET_PROJECTS_SUCCESS,
	GET_PROJECTS_FAIL,
	UPDATE_PROJECT_SUCCESS,
	UPDATE_PROJECT_FAIL,
	SET_PROJECT_LOADING,
	CLEAR_PROJECT_ERROR,
	DELETE_PROJECT_SUCCESS,
	DELETE_PROJECT_FAIL,
} from './types';

const initialState = {
	loading: false,
	project: null,
	projects: [],
};

const projectReducer = function (state = initialState, action) {
	switch (action.type) {
		// this is for fetching loading time setter
		case SET_PROJECT_LOADING:
			return {
				...state,
				loading: true,
			};

		case CLEAR_PROJECT_ERROR:
			return {
				...state,
				error: null,
				updated: false,
				project: null,
			};

		case ADD_PROJECT_SUCCESS:
			return {
				...state,
				project: action.payload,
				loading: false,
			};

		case GET_PROJECTS_SUCCESS:
			return {
				...state,
				projects: action.payload,
				loading: false,
			};

		case GET_PROJECT_SUCCESS:
			return {
				...state,
				project: action.payload,
				loading: false,
			};

		case UPDATE_PROJECT_SUCCESS:
		case DELETE_PROJECT_SUCCESS:
			return {
				...state,
				project: action.payload,
				loading: false,
				updated: true,
				projects: state.projects.map((project) => {
					if (project._id === action.payload._id) {
						return action.payload;
					} else {
						return project;
					}
				}),
			};

		case GET_PROJECTS_FAIL:
		case GET_PROJECT_FAIL:
		case UPDATE_PROJECT_FAIL:
		case ADD_PROJECT_FAIL:
		case DELETE_PROJECT_FAIL:
			return {
				loading: false,
				error: action.payload,
			};

		default:
			return state;
	}
};

export default projectReducer;
